<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section">
      <h1 class="mb-2 text-center title-s1 c-primary">Preguntas frecuentes</h1>

      <h5 class="txt-c-secondary">Sobre Reservas y Pagos</h5>
      <div>
        <h6>1. ¿Cómo puedo reservar un viaje?</h6>
        <p>
          Es muy fácil reservar con nosotros solo escribe a nuestros números de contacto, redes sociales o contacta un agente certificado Viajare y nosotros nos encargamos de hacer toda la reservación de tus servicios.
        </p>
      </div>

      <div>
        <br />
        <h6>2. ¿Cuáles son las formas de pago aceptadas?</h6>
        <p>
          Aceptamos pagos en efectivo, transferencias y tarjetas. Consulta nuestros métodos de pago en: <router-link to="/facilidades-de-pago">https://viajare.shop/#/facilidades-de-pago</router-link>
        </p>
      </div>

      <div>
        <br />
        <h6>3. ¿Puedo hacer un depósito para reservar mi viaje?</h6>
        <p>
          Dependiendo de la fecha de tu viaje es la cantidad que debes depositar para reservar, hay viajes que puedes reservar apartando con una cantidad mínima y otros dónde se te pedirá la totalidad de tu reserva.
        </p>
      </div>

      <div>
        <br />
        <h6>4. ¿Puedo cambiar o cancelar mi reserva?</h6>
        <p>
          Nuestra gama de productos es muy amplia. Por lo que tendrás que acercarte con tu agente Viajare para que te oriente en el proceso.
        </p>
      </div>

      <br /><br />
      <h5 class="txt-c-secondary">Sobre Vuelos</h5>
      <div>
        <h6>1. ¿Cuál es la mejor época para comprar boletos de avión más baratos?</h6>
        <p>
          La mejor época para comprar boletos de avión más baratos es en temporada baja, que suele ser en enero, febrero y septiembre. Por otro lado, las temporadas altas, como el verano y las vacaciones de fin de año, suelen tener tarifas más elevadas.
        </p>
      </div>

      <div>
        <br />
        <h6>2. ¿Cómo puedo hacer un check-in en línea?</h6>
        <p>
          Nosotros podemos ayudarte a realizar el check in de tu vuelo, sin embargo para realizarlo solo necesitas tu nombre y clave de reservación.
        </p>
      </div>

      <div>
        <br />
        <h6>3. ¿Qué hago si mi vuelo es cancelado o retrasado?</h6>
        <p>
          Es importante que notifiques a tu agente Viajare al momento, tu agente te orientará sobre los pasos a seguir.
        </p>
      </div>

      <br /><br />
      <h5 class="txt-c-secondary">Sobre Documentación y Visas</h5>
      <div>
        <h6>1. ¿Necesito visa para mi destino?</h6>
        <p>
          Puedes consultar en la página de la Secretaría de Relaciones Exteriores, además de que podrás encontrar información valiosa sobre tu o tus destinos de viaje.
        </p>
      </div>

      <div>
        <h6>2. ¿Cuánto tiempo de validez debe tener mi pasaporte?</h6>
        <p>
          Las regulaciones y condiciones migratorias por país pueden variar. Sin embargo, lo mejor es optar por una vigencia de más de 6 meses naturales de acuerdo a la fecha de regreso. Esto quiere decir, que si tu viaje termina el 01 de Diciembre, deberá tener vigencia hasta el 1ro de Junio para evitar retrasos o cuestionamientos por parte de migración.
        </p>
      </div>

      <div>
        <h6>3. ¿Qué documentos necesito para viajar con menores?</h6>
        <p>
          Para viajar con menores de edad, se requieren varios documentos, entre ellos:
        </p>
        <ul>
          <li>Formato SAM: Este documento es gratuito y se tramita en el sitio del Instituto Nacional de Migración (INM). Se necesita para que los menores de edad puedan viajar al extranjero, solos o con un tercero mayor de edad. El Formato SAM es una alternativa al poder notarial y al documento emitido por la autoridad judicial.</li>
          <li>Identificación oficial del menor: Puede ser el acta de nacimiento mexicana, CURP o pasaporte.</li>
          <li><strong class="f-w-500">Identificación oficial de los padres o tutores:</strong> Se requieren tres copias impresas.</li>
          <li>Autorización de viaje de la aerolínea: Esta autorización debe ser firmada por alguno de los padres o tutores legales del menor.</li>
        </ul>
        <p>
          En algunas ocasiones podrán solicitarle una carta notarial, aquí te presento las diferencias;
        </p>
        <ul>
          <li>
            Carta notarial: Es una autorización notariada firmada por los padres o tutores legales del menor ante un notario público. Puede ser más aceptada en ciertos casos, como cuando se requiere una autorización formal adicional para el viaje.
          </li>
          <li>
            Formato SAM: Es un formato gratuito proporcionado por el Instituto Nacional de Migración (INM) de México, que se usa específicamente para la salida de menores no acompañados por alguno de sus padres o tutores.
          </li>
        </ul>
        <p>
          ¿Cuándo es necesaria la carta notarial?
        </p>
        <ul>
          <li>
            En casos en los que la aerolínea, el país de destino o una situación particular requiera una autorización notariada.
          </li>
          <li>
            Cuando los padres prefieren utilizar un documento con validez notarial adicional a la autorización del INM.
          </li>
        </ul>
        <p>
          Es importante verificar con la aerolínea o las autoridades migratorias específicas si la carta notarial será requerida además del Formato SAM para evitar inconvenientes al momento de salir del país.
        </p>
      </div>

      <br /><br />
      <h5 class="txt-c-secondary">Sobre Paquetes de Viaje</h5>
      <div>
        <h6>1. ¿Qué incluyen los paquetes de viaje?</h6>
        <p>
          Los servicios pueden variar, dependerá del paquete que elijas y la confirmación de tus servicios al adquirir tu viaje.
        </p>
      </div>

      <div>
        <h6>2. ¿Puedo personalizar mi paquete de viaje?</h6>
        <p>
          ¡Claro que puedes! Contamos con personal preparado para diseñar viajes a la medida. Para esto, te citaremos para tener una plática más profunda sobre tus expectativas e imprescindibles para el viaje de tus sueños.
        </p>
      </div>

      <div>
        <h6>3. ¿Cómo se gestionan los tours y actividades durante el viaje?</h6>
        <p>
          Tu agente Viajare debe brindarte toda esta información, ya que cada servicio es una experiencia única. Si no lo recibes en menos de 72 horas de acuerdo a la fecha de tu actividad o tour, contáctanos.
        </p>
      </div>

      <br /><br />
      <h5 class="txt-c-secondary">Sobre Seguros de Viaje</h5>
      <div>
        <h6>1. ¿Es obligatorio contratar un seguro de viaje?</h6>
        <p>
          Puedes consultar en la página de la Secretaría de Relaciones Exteriores, además de que podrás encontrar información valiosa sobre tu o tus destinos de viaje.
        </p>
      </div>

      <div>
        <h6>2. ¿Qué cubre el seguro de viaje?</h6>
        <p>
          Los servicios pueden variar, dependerá del paquete que elijas y las necesidades que puedas enfrentar durante tu viaje. ¡Contamos con distintas opciones!
        </p>
      </div>

      <br /><br />
      <h5 class="txt-c-secondary">Sobre Alojamiento</h5>
      <div>
        <h6>1. ¿Cómo se seleccionan los hoteles?</h6>
        <p>
          Explica cómo la agencia elige los alojamientos y qué criterios se consideran.
        </p>
      </div>

      <div>
        <h6>2. ¿Puedo elegir mi hotel?</h6>
        <p>
          Por supuesto que sí, aunque las opciones pueden variar, dependerá del paquete que elijas y la confirmación de tus servicios al adquirir tu viaje.
        </p>
      </div>

      <div>
        <h6>3. ¿Los hoteles incluyen comidas?</h6>
        <p>
          Aclara si el alojamiento incluye desayuno, media pensión o todo incluido.
        </p>
      </div>

      <br /><br />
      <h5 class="txt-c-secondary">Sobre Asistencia en el Destino</h5>
      <div>
        <h6>1. ¿Qué hago si tengo un problema durante mi viaje?</h6>
        <p>
          Comunicarte con tu agente Viajare a la brevedad, él te orientará y buscaremos la mejor solución.
        </p>
      </div>

      <div>
        <h6>2. ¿La agencia ofrece guías turísticos?</h6>
        <p>
          Los servicios pueden variar, dependerá del paquete que elijas y la confirmación de tus servicios al adquirir tu viaje.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
